import React, { ReactElement } from "react"
import { Tabs, Tab } from "@wfp/ui"
import { XlsFormResult } from "interfaces/xlsForm"

type Props = {
  data: XlsFormResult
}

const ValidationFormSchema = ({ data }: Props): ReactElement | null => {
  const { errors, warnings } = data

  if (!errors?.length) return null

  return (
    <div className="mt-12">
      <Tabs>
        <Tab label="Errors" href="" role="tab" selected tabIndex={0}>
          <div className="border-gray-300 border-solid border p-3 text-sm overflow-auto text-justify">
            {errors.map(error => (
              <div key={error.message} className="mb-1">
                <p className="font-bold">{error.message}</p>
                <p>{error.list}</p>
              </div>
            ))}
          </div>
        </Tab>

        {!!warnings?.length && (
          <Tab label="Warning" href="" role="tab" selected={false} tabIndex={0}>
            <div className="border-gray-300 border-solid border p-3 text-sm overflow-auto text-justify">
              {warnings.map(warning => (
                <div key={warning.message} className="mb-1">
                  <p className="font-bold">{warning.message}</p>
                  <p>{warning.list}</p>
                </div>
              ))}
            </div>
          </Tab>
        )}
      </Tabs>
    </div>
  )
}

export default ValidationFormSchema
